import { createFileRoute } from "@tanstack/react-router"
import { DashboardPage } from "@/pages/DashboardPage"

// Data loads via tRPC/React Query on mount (useDashboard + guides.list*); no
// react-db preload needed. Auth gating lives in the `_authenticated` parent
// component, so navigation here doesn't block on a session fetch.
export const Route = createFileRoute(`/_authenticated/dashboard`)({
  component: DashboardPage,
  ssr: false,
})
